import { Time } from '@angular/common';

export interface IReminderContainer {
  defaultReminder: Reminder;
  reminders: Reminder[];
}

export interface IReminder {
  _id: string;
  time: Time;
  repeatOnDays: { mo: boolean; di: boolean; mi: boolean; do: boolean; fr: boolean; sa: boolean; so: boolean };
  isActive: boolean;
}

export class Reminder {
  _id: string;
  time: Time = { hours: undefined, minutes: undefined };
  repeatOnDays: { mo: boolean; di: boolean; mi: boolean; do: boolean; fr: boolean; sa: boolean; so: boolean } = {
    mo: false,
    di: false,
    mi: false,
    do: false,
    fr: false,
    sa: false,
    so: false,
  };
  isActive: boolean = true;

  constructor() {}
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/models/Reminder.ts